import { environment } from '../../environments/environment';

export class UrlConfig {
    private static baseUrl = environment.baseUrl;
    private static urls = {
        // vehicles
        getAllMakersByYear: 'individual/fuelgov/years/',
        getEmissionValue: 'profileprocess',
        // Region Average
        getRegionAverage: 'individual/region',
        // trees, DollarAmt
        getPrice: 'individual/trees',
        // ZIP code
        verifyZipCode: 'verifyzipcode',
        // Leads
        leads: 'leads',
        // limit user's count of calculations per day
        checkEmail: 'checkemail',
        getStateAndCountry: 'getstateandcountry'
    };

    static get(property) {
        return this[property];
    }

    static getUrl(path, params = []) {
        let paramsString = '';

        params.forEach((param) => {
            paramsString += param + '/';
        });

        return this.get('baseUrl') + this.urls[path] + paramsString;
    }

}



// WEBPACK FOOTER //
// ./src/app/config/urlConfig.ts